<script setup lang="ts">
import type { IVDialogProps } from '@/types/components/vDialog';
import { useSlots } from 'vue';

type DialogProps = { title: string; isLoading?: boolean; showCloseButton?: boolean };

withDefaults(defineProps<IVDialogProps & DialogProps>(), {
    showCloseButton: true
});

const isDialogOpen = defineModel<boolean>();
const slots = useSlots();
</script>

<template>
    <v-dialog v-model="isDialogOpen" max-width="900" width="100%">
        <v-card class="pa-6" :loading="isLoading">
            <v-card-title class="d-flex justify-space-between align-center pl-0 mb-4">
                <span class="text-truncate mr-5">
                    <strong>{{ title }}</strong>
                    <slot name="appendTitle"></slot>
                </span>
                <v-avatar v-if="showCloseButton" class="hover-main" size="26" @click="isDialogOpen = false" icon="close" />
            </v-card-title>
            <div class="dialog-content">
                <slot></slot>
            </div>
            <v-card-actions v-if="slots.actions">
                <slot name="actions"></slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
